import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/rate/style/index.js
// module id = gi6D
// module chunks = 15